import PropTypes from 'prop-types';

import { CurrencyPropType } from './currency';
import { DimensionPropType } from './dimension';
import { ShipFromPropType } from './ship-from';
import { TrackingSummaryPropType } from './tracking-summary';
import { WeightPropType } from './weight';

export const FulfillmentPropType = PropTypes.shape({
  fulfillmentId: PropTypes.string,
  trackingInformation: TrackingSummaryPropType,
  deliveryNotificationTemplateId: PropTypes.string,
  shipFrom: ShipFromPropType,
  weight: WeightPropType,
  dimensions: DimensionPropType,
  shipDateTime: PropTypes.string,
  expectedDeliveryDateTime: PropTypes.string,
  insuranceCost: CurrencyPropType,
  labelCost: CurrencyPropType,
  labelProviderId: PropTypes.string,
  serviceId: PropTypes.string,
  packageTypeId: PropTypes.string,
  confirmation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shippingOptions: PropTypes.string,
  properties: PropTypes.shape({
    hasCustomsForm: PropTypes.bool,
    hasFormFile: PropTypes.bool,
  }),
  isLabelVoided: PropTypes.bool,
  labelPrintedStatus: PropTypes.shape({
    labelId: PropTypes.string,
    isPrinted: PropTypes.bool,
  }),
});

/**
 * @typedef {object} FulfillmentPropType
 * @property {string} fulfillmentId
 * @property {TrackingSummaryPropType} trackingInformation
 * @property {string} deliveryNotificationTemplateId
 * @property {ShipFromPropType} shipFrom
 * @property {WeightPropType} weight
 * @property {DimensionsPropType} dimensions
 * @property {string} shipDateTime
 * @property {string} expectedDeliveryDateTime
 * @property {CurrencyPropType} insuranceCost
 * @property {CurrencyPropType} labelCost
 * @property {string} labelProviderId
 * @property {string} serviceId
 * @property {string|number} confirmation
 * @property {string} shippingOptions
 * @property {object} properties
 * @property {boolean} properties.hasCustomsForm
 * @property {boolean} properties.hasFormFile
 * @property {boolean} isLabelVoided
 * @property {object} labelPrintedStatus
 * @property {string} labelPrintedStatus.labelId
 * @property {boolean} labelPrintedStatus.isPrinted
 */
